class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    
    // Ensure we're not in a loading state on initialization
    this.removeAttribute('loading');

    this.setupEventListeners();
  }
setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

    document.addEventListener('pointerdown', this.onPointerDown.bind(this), true);
    document.addEventListener('click', this.onClickOutside.bind(this), true);
}

onPointerDown(event) {
    this.isClickInside = this.contains(event.target);
}

onFocusOut(event) {
    console.log("Focusout event fired", event.relatedTarget);

    if (this.isClickInside) {
        console.log("Focus moved out but pointerdown was inside, not closing.");
        return;
    }

    setTimeout(() => {
        // Don't close if we're in a loading state (form is submitting)
        if (this.getAttribute('loading') === 'true') {
            console.log("Loading state active, not closing dropdown.");
            return;
        }
        
        if (!this.matches(':focus-within')) {
            console.log("No element inside dropdown focused, closing dropdown.");
            this.close();
        }
    }, 100);
}

onClickOutside(event) {
    console.log("Click event fired", event.target);

    // Don't close if we're in a loading state (form is submitting)
    if (this.getAttribute('loading') === 'true') {
        console.log("Loading state active, not closing dropdown.");
        return;
    }

    // Don't close if the click is on a menu drawer back button
    if (event.target.classList.contains('menu-drawer__close-button')) {
        console.log("Click on menu drawer back button, not closing search dropdown.");
        return;
    }

    // Don't close if the click is inside the predictive search component
    if (this.contains(event.target)) {
        return;
    }

    // Don't close if the click is on other important UI elements that shouldn't close the search
    if (event.target.closest('header-drawer, menu-drawer, .cart-drawer, .modal-dialog')) {
        console.log("Click on important UI element, not closing search dropdown.");
        return;
    }

    console.log("Click detected outside, closing search dropdown.");
    this.close();
}

  getQuery() {
    return this.input.value.trim();
}

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      // Don't close the dropdown if we have a button interaction
      if (!document.querySelector('.quantity__button:hover')) {
        this.close(true);
      }
      return;
    }

    this.getSearchResults(this.searchTerm);
}


  onFormSubmit(event) {
    const selectedOption = this.querySelector('[aria-selected="true"] a');
    if (!this.getQuery().length || selectedOption) {
      event.preventDefault();
      return;
    }
    
    // If there's a query and no selected option, clear results, show loading spinner and keep dropdown open
    if (this.getQuery().length) {
      event.preventDefault();
      
      // Clear the results from the dropdown
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
      this.querySelector('#predictive-search-option-search-keywords')?.remove();
      this.removeAttribute('results');
      
      // Set loading state FIRST (synchronously)
      this.setAttribute('loading', 'true');
      this.setAttribute('open', 'true');
      this.input.setAttribute('aria-expanded', 'true');
      
      // Ensure loading spinner is visible
      const loadingSpinner = this.querySelector('.predictive-search__loading-state');
      if (loadingSpinner) {
        loadingSpinner.classList.remove('hidden');
      }
      
      // Set max height to keep dropdown visible
      if (!this.resultsMaxHeight) {
        this.resultsMaxHeight = window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom || 300;
      }
      this.predictiveSearchResults.style.maxHeight = `${this.resultsMaxHeight}px`;
      
      // Set sessionStorage flag to indicate we're navigating from search
      sessionStorage.setItem('predictiveSearchSubmitting', 'true');
      
      // Use requestAnimationFrame to ensure spinner is rendered before form submission
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.input.form.submit();
        });
      });
    }
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
  this.input.value = ''; // Clear the search bar when clicked

    const currentSearchTerm = this.getQuery();
  
    if (!currentSearchTerm.length) return;

    this.input.style.borderColor = 'rgb(var(--color-shadow))';
  
    this.setAttribute('open', true);
  
    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }


  //onFocusOut() {
  //    setTimeout(() => {
  //        if (!this.contains(document.activeElement) && 
  //            !document.querySelector('.quantity__button:hover') &&
  //            !document.querySelector('.cart-updating')) { // Prevents closing when cart updates
  //            this.close();
  //            this.input.style.borderColor = ''; 
  //        }
  //    });
  //}


  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);

    switch (event.code) {
      case 'ArrowUp':
        event.preventDefault();
        this.switchOption('up');
        break;
      case 'ArrowDown':
        event.preventDefault();
        this.switchOption('down');
        break;
      case 'Enter':
        // Enter key handling is now done in onKeydown to ensure form submission works on mobile
        // This prevents the form from submitting twice
        event.preventDefault();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
    
    // Handle Enter key in keydown to ensure form submission works on mobile
    if (event.code === 'Enter') {
      const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
      if (selectedOption) {
        // If there's a selected option, prevent default and click it
        event.preventDefault();
        this.selectOption();
      } else if (this.getQuery().length) {
        // If no selected option but there's a query, prevent default and handle submission ourselves
        event.preventDefault();
        
        // Clear results and show loading state
        this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
        this.querySelector('#predictive-search-option-search-keywords')?.remove();
        this.removeAttribute('results');
        
        // Set loading state FIRST (synchronously)
        this.setAttribute('loading', 'true');
        this.setAttribute('open', 'true');
        this.input.setAttribute('aria-expanded', 'true');
        
        // Ensure loading spinner is visible
        const loadingSpinner = this.querySelector('.predictive-search__loading-state');
        if (loadingSpinner) {
          loadingSpinner.classList.remove('hidden');
        }
        
        // Set max height to keep dropdown visible
        if (!this.resultsMaxHeight) {
          this.resultsMaxHeight = window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom || 300;
        }
        this.predictiveSearchResults.style.maxHeight = `${this.resultsMaxHeight}px`;
        
        // Use requestAnimationFrame to ensure spinner is rendered before form submission
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.input.form.submit();
          });
        });
      }
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&limit=100`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
    
    // Change border color
    this.input.style.borderColor = 'rgb(var(--color-shadow))';
  }
  
  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  
    // Reset border color
    this.input.style.borderColor = ''; // Or set to the default border color
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
